import { Box, styled, Typography } from '@mui/material';

export const DailySurveyWrapper = styled(Box)(({ theme }) => ({
  padding         : '20px 40px',
  border          : `1px solid ${theme.palette.primary.gray3}`,
  borderRadius    : '10px',
  color           : '#231F20',
  backgroundColor : theme.palette.primary.white,
  position        : 'relative',
  width           : { md: '60%' },
  display         : 'flex',
  flex            : 1,
  flexDirection   : 'column',
  alignItems      : 'flex-start',
}));

export const Title = styled(Typography)({
  color      : '#231F20',
  fontFamily : 'Montserrat',
  fontWeight : '700',
});
